import React from 'react';
import { DropletIcon, LeafIcon, NavigationIcon, RouteIcon, ScrollTextIcon, ShieldCheckIcon, WavesIcon, WifiIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { amenities } from '../data/site';
const icons: Record<string, React.ComponentType<{
  size?: number;
  strokeWidth?: number;
}>> = {
  road: RouteIcon,
  droplet: DropletIcon,
  zap: ZapIcon,
  shield: ShieldCheckIcon,
  leaf: LeafIcon,
  scroll: ScrollTextIcon,
  navigation: NavigationIcon,
  wifi: WifiIcon,
  pipe: WavesIcon
};
export function Amenities() {
  return <section id="amenidades" className="bg-sand py-20 lg:py-28" data-id="element-15" data-mp="37aga5w122h0o">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-16" data-mp="3c9sx0grxfo39">
        <SectionHeading title="Todo listo desde el primer día" description="El Rodeo se entrega urbanizado. Usted solo se preocupa por decidir dónde va la puerta de su casa." data-id="element-17" data-mp="3c8hwcpts2wgd" />

        <ul className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-sm bg-forest-900/10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-18" data-mp="8narmf9fxfjx">
          {amenities.map((amenity, index) => {
          const Icon = icons[amenity.icon];
          return <Reveal key={amenity.label} as="li" delay={index * 0.03} className="flex h-full items-center gap-4 bg-white px-6 py-7" data-id="element-19" data-mp="38o78wfgh3dvw" data-mpi={index}>
                <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full bg-gold-100 text-gold" data-id="element-20" data-mp="3hnm0xjcafwii">
                  <Icon size={22} strokeWidth={1.7} data-id="element-21" data-mp="3cp0wt8tx0sos" />
                </span>
                <span className="text-[14px] font-medium uppercase tracking-[0.08em] text-forest-900" data-id="element-22" data-mp="3rn30dj0y5e61">
                  {amenity.label}
                </span>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}